// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9c8dd31","623":"17bfa0a1"}[chunkId] + ".chunk.js";
};